module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "div_out weex-ct weex-div",
    style: ({
      marginLeft: _vm._px2rem(_vm.divLeft, 75),
      width: _vm._px2rem(_vm.imgWidth, 75)
    }),
    attrs: {
      "weex-type": "div"
    }
  }, [_c('slider', {
    staticClass: "slider",
    style: (_vm._px2rem(_vm.sliderStyle, 75)),
    attrs: {
      "interval": _vm.interval,
      "auto-play": _vm.autoplay,
      "infinite": _vm.infinite,
      "data-evt-change": ""
    },
    nativeOn: {
      "change": function($event) {
        $event.stopPropagation();
        return _vm.change($event)
      }
    }
  }, [_vm._l((_vm.slItems), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: " weex-ct weex-div",
      attrs: {
        "weex-type": "div",
        "data-evt-click": ""
      },
      on: {
        "click": _vm.$stopOuterA,
        "weex$tap": function($event) {
          $event.stopPropagation();
          return _vm.imgClicked(item, index)
        }
      }
    }, [_c('figure', {
      directives: [{
        name: "weex-resize",
        rawName: "v-weex-resize",
        value: (_vm.imgResize),
        expression: "imgResize"
      }],
      staticClass: "image weex-el weex-image",
      style: ({
        width: _vm._px2rem(_vm.imgWidth, 75),
        height: _vm._px2rem(_vm.imgHeight, 75),
        backgroundColor: _vm.imageBgColor
      }),
      attrs: {
        "resize": _vm.imgResize,
        "src": item.url,
        "placeholder": _vm.phImgUrl,
        "data-img-src": item.url,
        "weex-type": "image"
      }
    })])
  }), _vm._v(" "), (_vm.showIndicator && !_vm._isColmo) ? _c('indicator', {
    staticClass: "indicator",
    style: (_vm._px2rem(_vm.indicatorStyle, 75)),
    attrs: {}
  }) : _vm._e()], 2), _vm._v(" "), (_vm.showIndicator && _vm._isColmo) ? _c('div', {
    staticClass: "indicator-box weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, _vm._l((_vm.slItems), function(item, i) {
    return _c('div', {
      key: i,
      staticClass: " weex-ct weex-div",
      class: ['indicator-item', i === _vm.slItems.length - 1 && 'isLast', i == _vm.active && 'active'],
      attrs: {
        "weex-type": "div"
      }
    })
  }), 0) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c6148e1a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c6148e1a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-swiper/index.vue
// module id = 658
// module chunks = 0 1